import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";

const SlotChangeProposalAlgorithmHelpDialog = ({ visible, onHide }) => (
  <Dialog
    header="Comment sont proposées les affectations ?"
    visible={visible}
    onHide={onHide}
    style={{ width: "min(52rem, 95vw)" }}
    modal
  >
    <div className="flex flex-column gap-3 line-height-3">
      <p className="m-0">
        Le bouton <strong>Proposer les affectations</strong> calcule une proposition
        automatique pour les demandes de changement de créneau encore en attente. Il
        ne modifie rien tant que vous n'approuvez pas explicitement les propositions
        sélectionnées.
      </p>

      <Divider className="my-2" />

      <section>
        <h4 className="mt-0 mb-2">1. Ordre de priorité des demandes</h4>
        <p className="m-0">
          Les demandes sont traitées dans l'ordre suivant : d'abord l'urgence
          (<strong>Urgente</strong>, puis <strong>Prioritaire</strong>, puis{" "}
          <strong>Neutre</strong>), ensuite la date et l'heure de la demande, de la
          plus ancienne à la plus récente.
        </p>
      </section>

      <section>
        <h4 className="mt-0 mb-2">2. Prise en compte de tous les choix</h4>
        <p className="m-0">
          Pour une demande donnée, l'algorithme essaie tous les créneaux souhaités
          dans l'ordre indiqué : 1er choix, puis 2e choix, puis les suivants. Une
          demande prioritaire peut donc obtenir son 2e choix avant qu'une demande
          moins prioritaire n'obtienne son 1er choix.
        </p>
      </section>

      <section>
        <h4 className="mt-0 mb-2">3. Classes candidates</h4>
        <p className="m-0">
          Pour chaque créneau souhaité, seules les classes du même niveau que l'élève
          sont candidates. La classe actuelle de l'élève est exclue, ainsi que les
          classes brouillon ou bloquées. La classe doit réellement être programmée sur
          le créneau demandé.
        </p>
      </section>

      <section>
        <h4 className="mt-0 mb-2">4. Places disponibles et équilibre des classes</h4>
        <p className="m-0">
          Si plusieurs classes conviennent, l'algorithme privilégie les classes les
          moins remplies afin d'équilibrer les effectifs. Une classe avec une capacité
          maximale à 0 est considérée comme sans limite de capacité.
        </p>
      </section>

      <section>
        <h4 className="mt-0 mb-2">5. Échanges et rotations</h4>
        <p className="m-0">
          Quand aucune place directe n'est disponible, l'algorithme recherche des
          échanges entre élèves, ou des rotations de plusieurs élèves, pour libérer
          des places tout en respectant les créneaux demandés.
        </p>
      </section>

      <section>
        <h4 className="mt-0 mb-2">6. Demandes sans solution</h4>
        <p className="m-0">
          Une demande est listée comme sans solution si aucune classe du même niveau
          n'existe sur les créneaux souhaités, si aucune place ou échange n'est
          possible, ou si la classe/le créneau actuel de l'élève a changé depuis la
          création de la demande.
        </p>
      </section>
    </div>
  </Dialog>
);

export default SlotChangeProposalAlgorithmHelpDialog;
